/* eslint-disable */
import * as putils from '@bingads-webui-universal/primitive-utilities';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as Url from '@bingads-webui/url-util';
import config from '@bingads-webui-component-legacy/config/index';
import _ from 'underscore';
import * as adExtensionsShared from '@bingads-webui-campaign/ads-globalization';
function getCountriesFilter() {
  var includedCountries = adExtensionsShared.globalizationModelSetup({
    permissions: config.get('permissions') || ({}),
    culture: config.get('culture')
  }).COUNTRIES;
  return function countriesFilter(entry) {
    return _.contains(includedCountries, entry.Key);
  };
}
var cid = Url.getParameter('cid') || '', uid = Url.getParameter('uid') || '', urlTemplate = '/Campaign/Address/SchemaCountry/country({{countryCode}})/?cid=' + cid + '&uid=' + uid + '&locale={{locale}}&countryset=Publisher';
export function load(locale, countryCode) {
  var url = putils.curlyTemplate(urlTemplate)({
    countryCode: countryCode,
    locale: locale
  });
  var countriesFilter = getCountriesFilter();
  return jsdata.Country.find(countryCode, {
    url: url,
    adapter: 'legacy'
  }).then(function (response) {
    return {
      Countries: _.filter(response.Schema.Countries, countriesFilter),
      AdminDistricts: response.Schema.AdminDistricts
    };
  });
}
export default {
  load: load
};

